<template>
    <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card class="box no-display">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Leaving Certificate </strong>
          <v-icon @click="onload" title="Reload list" dark color="yellow"
            >mdi-reload</v-icon
          >
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center">
        <v-col cols="12" sm="4" md="4" class="mt-3">
          <v-combobox
            class="no-display"
            v-model="registration_no"
            @change="checkHistory"
            :loading="comp_load"
            rounded
            :items="stud_list"
            label="Select Student"
            item-text="name"
            outlined
            dense
            prepend-icon="mdi-account-child-circle"
          ></v-combobox>
        </v-col>
      </v-row>
      <div v-if="registration_no != null">
        <template>
          <v-expansion-panels class="expapanel no-display mb-6" focusable inset>
            <v-expansion-panel>
              <v-expansion-panel-header class="panelheader"
                >Account History
              </v-expansion-panel-header>
              <v-expansion-panel-content class="mt-5">
                <v-data-table
                  :headers="headers_1"
                  :items="ay_record"
                  class="elevation-1 mytable"
                  dense
                >
                  <template v-slot:item.status="{ item }">
                    <v-chip :color="getColor(item.status)" dark>
                      {{ item.status }}
                    </v-chip>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-expansion-panels class="expapanel no-display" focusable inset>
            <v-expansion-panel>
              <v-expansion-panel-header class="panelheader"
                >Academic History
              </v-expansion-panel-header>
              <v-expansion-panel-content class="mt-5">
                <!-- table content -->

                <v-data-table
                  :headers="headers_2"
                  :items="ay_record_div"
                  dense
                  class="elevation-1 mytable"
                >
                </v-data-table>
                <!-- table end -->
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>

        <!-- radio button -->
        <v-row justify="center" dense class="no-display">
          <v-radio-group
            v-model="fetch_gen_toggle"
            mandatory
            row
            class="radiobtn"
          >
            <v-radio label="Fetch LC" value="FETCH"></v-radio>
            <v-radio label="Generate LC" value="GENERATE"></v-radio>
          </v-radio-group>
        </v-row>
        <!-- radio button end -->
        <v-row justify="center" v-if="ay_record.length != 0">
          <div class="fees no-display">
            <span v-if="account_status" style="color: #4caf50"
              >Fees Clear
            </span>
            <span v-else style="color: #f44336">Fees Pending</span>
          </div>
        </v-row>
      </div>
    </v-card>
    <div v-if="registration_no != null">
      <!-- generate lc code -->
      <template v-if="fetch_gen_toggle == 'GENERATE'">
        <!-- Date starts -->
        <v-row justify="center" class="mt-3">
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                dense
                v-model="last_date_of_school"
                @blur="date = parseDate(last_date_of_school)"
                v-on="on"
                hint="Last Date of Leaving"
                prepend-icon="event"
                persistent-hint
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              no-title
              @input="menu1 = false"
            ></v-date-picker>
          </v-menu>

          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                dense
                v-model="gen_date"
                @blur="date = parseDate(gen_date)"
                v-on="on"
                hint="Generation Date"
                prepend-icon="event"
                persistent-hint
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date2"
              no-title
              @input="menu2 = false"
            ></v-date-picker>
          </v-menu>
          <v-menu
            ref="menu4"
            v-model="menu4"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="attrs"
                dense
                v-model="application_date"
                @blur="date = parseDate(application_date)"
                v-on="on"
                hint="Date Of Application"
                prepend-icon="event"
                persistent-hint
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date_of_application"
              no-title
              @input="menu4 = false"
              @change="setToText()"
            ></v-date-picker>
          </v-menu>
          <v-menu
            ref="menu3"
            v-model="menu3"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="attrs"
                dense
                v-model="issue_date"
                @blur="date = parseDate(issue_date)"
                v-on="on"
                hint="Date Of Issue"
                prepend-icon="event"
                persistent-hint
              ></v-text-field>
            </template>
            <v-date-picker
              label="Issue Date"
              v-model="date_of_issue"
              no-title
              @input="menu3 = false"
              @change="setToText2()"
            ></v-date-picker>
          </v-menu>
        </v-row>
        <!-- Date ends -->
        <v-row justify="center" class="mt-3">
          <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="progress"
              rounded
              :items="dvt_prog"
              label="Select Progress"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="conduct"
              rounded
              :items="dvt_conduct"
              label="Select Conduct"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="remark"
              rounded
              :items="dvt_remark"
              label="Select Remark"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="reason"
              rounded
              :items="dvt_reason"
              label="Select Reason"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col>
        </v-row>
        <v-row justify="center" class="mt-3">
          <v-checkbox
            color="#0f2027"
            v-model="mark_inactive"
            label="Do You Want To Mark Student Inactive After Generating LC.?"
          ></v-checkbox>
        </v-row>
        <v-row justify="center">
          <v-btn @click="genLC" :disabled="!condition">Generate LC</v-btn>
        </v-row>
      </template>
      <!-- generate lc code end -->
      <template v-if="fetch_gen_toggle == 'FETCH'">
        <v-btn class="button no-display" @click="fetchLC">Fetch LC</v-btn>
        <br />
      </template>
        <div id="document1" class="printdiv text-color" v-if="lc_data != null">
        <!-- <center><span>Note: Any Changes in this Leaving Certificate will be liable for Punishment.</span></center>
        <v-row>
          <v-col class="pb-0 pt-0" cols="6" sm="6" md="6" align="left">UDISE No. {{ lc_data.udise_no }}</v-col>
          <v-col class="pb-0 pt-0" cols="6" sm="6" md="6" align="right">College Index No. 
            <span>J-12.04.015</span>
            </v-col>
        </v-row>
        <hr> -->
        <v-row style="display: flex; height: 260px;">
          <v-col cols="2" sm="2" md="2"> 
              <!-- <center>
                      <img
                        :src="org_basic_data.school_logo"
                        alt="school_logo"
                        height="120px"
                        width="170px"
                      />
                    </center> -->
          </v-col>
          <v-col cols="9" sm="9" md="9" class="white-text"> 
            <!-- <center>
            <span>{{ org_basic_data.trust_name }}</span>
            <h1>{{ org_basic_data.school_name }}</h1>
            <span>(Affiliated to Maharashtra State Board of Secondary and Higher Secondary Education, Pune.)</span><br>
            <span> {{ org_basic_data.address }}- {{org_basic_data.pin}}</span> <br>
            <span>Phone : {{ org_basic_data.phone }}</span>
            </center> -->
          </v-col>
        </v-row>
        <!-- <v-row>
        <v-col cols="12" sm="12" md="12" class="pb-0 pt-0" align="center">School Recog. No. <span>शिउस/उमाशि/पुवि/स्वअशामा/मान्यता/१४-१५/९१५९/६२ दि. २९ एप्रिल २०१४ </span></v-col>
        <v-col cols="12" sm="12" md="12" class="pb-0 pt-0" align="center" ><span style="margin-left: 135px;"> शिउस/उमाशि/पुवि/स्वअशामा/मान्यता/१४-१५/९१५५/५८ दि. २९ एप्रिल २०१४ </span></v-col>
        </v-row> -->
        <v-row>
          <v-col class="pb-0" cols="3" sm="3" md="3" style="align-content: center;">
            Certificate No. {{ lc_data.certificate_no}}
          </v-col>
          <v-col class="pt-0" cols="6" sm="6" md="6">
            <!-- <center><h2 style="color: rgb(235, 61, 61); font-size: 32px; text-decoration: underline;">LEAVING CERTIFICATE</h2></center> -->
          </v-col>
          <v-col class="pb-0" cols="3" sm="3" md="3" style="align-content: center;">
            G.R. No. {{ lc_data.gr_number }}
          </v-col>
        </v-row>
        <table class="jr-table">
          <tr>
            <td>APAAR ID</td>
            <td>{{ lc_data.apaar_id }}</td>
          </tr>
          <tr>
            <td>PEN ID</td>
            <td>{{ lc_data.pen_no }}</td>
          </tr>
          <tr>
            <td>Unique (Aadhaar No.)</td>
            <td>{{ lc_data.aadhar_no }}</td>
          </tr>
          <tr>
            <td>1) Name of the Student in Full</td>
            <td>{{ lc_data.fullname }}</td>
          </tr>
          <tr>
            <td>2) Mother's Name</td>
            <td>{{ lc_data.mother_first_name }}</td>
          </tr>
          <tr>
            <td>3) Nationality</td>
            <td style="width: 35%;">{{ lc_data.nationality }}</td>
            <td>4) Mother Tongue - {{ lc_data.mothertoungue }}</td>            
          </tr>
          <tr>
            <td>5) Religion, Caste & Sub-Caste</td>
            <td>{{ lc_data.religion }}-{{ lc_data.caste }}-{{ lc_data.subcaste }}</td>
          </tr>
          <tr>
            <td style="line-height: 100%">6) Place of Birth <br> <span style="font-size: small; margin-left: 15px;">(Village/City, Taluka, Zilla, State, Country)</span></td>
            <td>{{ lc_data.birth_place }}</td>
          </tr>
          <tr>
            <td style="line-height: 100%">7) Date of Birth <br> <span style="font-size: small; margin-left: 15px;">(According to Christian era)</span></td>
            <td>{{ lc_data.dob_fig }}</td>
          </tr>
          <tr>
            <td style="line-height: 100%">8) Date of Birth <br> <span style="font-size: small; margin-left: 15px;">(in words)</span></td>
            <td>{{ lc_data.dob_words }}</td>
          </tr>
          <tr>
            <td>9) Last School Attended Std.</td>
            <td>{{ lc_data.last_school }}</td>
          </tr>
          <tr>
            <td>10) Date of Admission & Std.</td>
            <td>{{ lc_data.doa }}</td>
            <td>Std. - {{ lc_data.admittedstandard }}</td>
          </tr>
          <tr>
            <td>11) Progress</td>
            <td>{{ lc_data.progress }}</td>
            <td>12) Conduct : {{ lc_data.conduct }}</td>
          </tr>
          <tr>
            <td>13) Date of leaving the college</td>
            <td>{{ lc_data.last_date_of_school }}</td>
          </tr>
          <tr>
            <td>14) Standard in which Studying & Since when <span style="font-size: small;">(in words & figures)</span></td>
            <td>{{ lc_data.standard }} Since {{ lc_data.standard_since_when }}</td>
          </tr>
          <tr>
            <td>15) Reason for Leaving the college</td>
            <td>{{ lc_data.reason }}</td>
          </tr>
          <tr>
            <td>16) Remarks</td>
            <td>{{ lc_data.remark }}</td>
          </tr>
        </table>
        <div style="color: rgb(235, 61, 61); padding: 17px 0px 5px 17px;">Certified that the above information is in accordance with the Institute's General Register No. {{ lc_data.gr_number }}</div>
        <span style="padding-left: 17px;">Certificate Issuing Date : {{ lc_data.date_of_issue }}</span>
        <v-row class="jr-last-row">          
          <v-col cols="4" sm="4" md="4" align="center"><b>CLASS TEACHER</b></v-col>
          <v-col cols="4" sm="4" md="4" align="center"><b>CLERK</b></v-col>
          <v-col cols="4" sm="4" md="4" align="center"><b>PRINCIPAL</b></v-col>          
        </v-row>
      </div>
    </div>
    <div class="no-display" v-if="lc_data != null">
      <div style="text-align: center">
        ----------------------------------Modify------------------------------------
      </div>
      <br />

      <v-row justify="center" class="mt-3">
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Student Progress"
            v-model.trim="lc_data.progress"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Conduct"
            v-model.trim="lc_data.conduct"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Student Remark"
            v-model.trim="lc_data.remark"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Student Reason"
            v-model.trim="lc_data.reason"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn class="mb-2 button" color="warning" @click="savegenLC()" small
          >Save</v-btn
        >
      </v-row>
      <hr />
      <v-row class="no-display">
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Birth in words"
            v-model.trim="lc_data.dob_words"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Last School"
            v-model.trim="lc_data.last_school"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Standard"
            v-model.trim="lc_data.standard"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Since when..."
            v-model.trim="lc_data.standard_since_when"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Caste"
            v-model.trim="lc_data.caste"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Religion"
            v-model.trim="lc_data.religion"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-btn @click="proceed" class="info">Proceed to print</v-btn>
      </v-row>
    </div> 
    </div>   
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
      data() {
    return {
      mark_inactive: false,
      headers_1: [
        { text: "Academic Year", value: "ay" },
        { text: "Paid", value: "paid" },
        { text: "Balance", value: "balance" },
        { text: "Status", value: "status" },
      ],
      headers_2: [
        { text: "Academic Year", value: "ay" },
        { text: "Roll No", value: "rollno" },
        { text: "Div", value: "div" },
        { text: "Std", value: "std" },
        { text: "Total", value: "total" },
        { text: "Present ", value: "present" },
      ],

      comp_load: false,
      fetch_loader: false,
      overlay: false,
      snackbar: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      registration_no: null,
      stud_list: [],
      ay_record: [],
      ay_record_div: [],
      account_status: false,
      dvt_prog: [],
      progress: null,
      dvt_conduct: [],
      conduct: null,
      dvt_reason: [],
      reason: null,
      dvt_remark: [],
      remark: null,
      fetch_gen_toggle: "FETCH",
      board_toggle: "SSC",
      //////date
      last_date_of_school: "",
      gen_date: "",
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      date_of_application: new Date().toISOString().substr(0, 10),
      date_of_issue: new Date().toISOString().substr(0, 10),
      application_date: "",
      issue_date: "",
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      nowDate: new Date().toISOString().slice(0, 10),
      ///
      lc_data: null,
      org_basic_data: null,
      condition: false,
      org_id: null,
    };
  },
  watch: {
    date(val) {
      this.last_date_of_school = this.formatDate(this.date);
    },
    date2(val) {
      this.gen_date = this.formatDate(this.date2);
    },
    date_of_application(val) {
      this.application_date = this.formatDate(this.date_of_application);
      this.lc_data.date_of_application = this.application_date;
    },
    date_of_issue(val) {
      this.issue_date = this.formatDate(this.date_of_issue);
      this.lc_data.date_of_issue = this.issue_date;
    },
  },
  methods: {
    setToText() {
      this.lc_data.date_of_application = this.application_date;
    },
    setToText2() {
      this.lc_data.date_of_issue = this.issue_date;
    },
    savegenLC() {
      const formData = {
        lid: this.registration_no.lid,
        progress: this.lc_data.progress,
        conduct: this.lc_data.conduct,
        remark: this.lc_data.remark,
        reason: this.lc_data.reason,
        gen_date: this.date_of_generation,
      };
      this.overlay = true;
      axios
        .post("/certificate/genLC", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.org_basic_data = res.data.org_basic_data;
            this.lc_data = res.data.lc_data;
            // this.lc_data.last_school = this.org_basic_data.school_name;
            this.showSnackbar("green", "Success..!!!");
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    proceed() {
      localStorage.setItem("lc_data", JSON.stringify(this.lc_data));
      localStorage.setItem(
        "org_basic_data",
        JSON.stringify(this.org_basic_data)
      );
      let routeData = this.$router.resolve({ name: "sjck-lc-print" });
      window.open(routeData.href, "_blank");
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    getColor(status) {
      if (status === "pending") return "red";
      if (status === "clear") return "green";
      if (status === "NA") return "gray";
    },

    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },

    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    onload() {
      this.ay_record = [];
      this.lc_data = null;
      this.org_basic_data = null;
      this.comp_load = true;
      axios
        .post("/admission/getAllStudents")
        .then((res) => {
          if (res.data.msg == "200") {
            this.stud_list = res.data.all_stud_list;
          } else {
            this.showSnackbar("red", "Something went wrong.");
          }
          this.comp_load = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.comp_load = false;
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
    checkHistory() {
      console.log("registration_no:", this.registration_no);
      this.ay_record = [];
      this.lc_data = null;
      this.org_basic_data = null;
      if (this.registration_no == null) {
        this.showSnackbar("red", "Please select student");
      }
      this.overlay = true;
      axios
        .post("/certificate/checkHistory", this.registration_no)
        .then((res) => {
          console.log("res", res.data);
          if (res.data.flag == "YES") {
            this.ay_record = res.data.ay_record;
            this.account_status = res.data.account_status;
            this.ay_record_div = res.data.ay_record_div;
            this.dvt_prog = res.data.dvt_prog;
            this.progress = this.dvt_prog[0];
            this.dvt_conduct = res.data.dvt_conduct;
            this.conduct = this.dvt_conduct[0];
            this.dvt_reason = res.data.dvt_reason;
            this.reason = this.dvt_reason[0];
            this.dvt_remark = res.data.dvt_remark;
            this.remark = this.dvt_remark[0];
            this.condition = res.data.condition;
            if (!this.condition)
              this.showSnackbar("red", res.data.condition_msg);
          } else {
            this.showSnackbar("red", res.data.snackbar);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    genLC() {
      if (this.account_status == false) {
        if (
          !confirm(
            "Are You Sure You Want To generate LC as fees is pending...?"
          )
        )
          return;
      }
      if (
        this.progress != null &&
        this.conduct != null &&
        this.last_date_of_school != "" &&
        this.gen_date != "" &&
        this.remark != null &&
        this.reason != null &&
        this.application_date != "" &&
        this.issue_date != ""
      ) {
        const formData = {
          lid: this.registration_no.lid,
          progress: this.progress,
          conduct: this.conduct,
          remark: this.remark,
          reason: this.reason,
          last_date_of_school: this.last_date_of_school,
          gen_date: this.gen_date,
          date_of_application: this.application_date,
          date_of_issue: this.issue_date,
          mark_inactive: this.mark_inactive,
        };
        this.overlay = true;
        axios
          .post("/certificate/genLC", formData)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.org_basic_data = res.data.org_basic_data;
              this.lc_data = res.data.lc_data;
              // this.lc_data.last_school = this.org_basic_data.school_name;
              // if (this.lc_data.caste == null) {
              //   alert("Caste is not enter ..");
              // }
              // this.showSnackbar("green", "User data fetched!!!");
            } else {
              this.showSnackbar("red", res.data.snackbar);
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
            this.overlay = false;
          })
          .catch((error) => {
            this.onerror(error);

            this.overlay = false;
          })
          .finally(() => {
            this.overlay = false;
          });
      } else {
        this.showSnackbar("red", "Please select/enter all data");
      }
    },
    fetchLC() {
      this.overlay = true;
      axios
        .post("/certificate/fetchLC", this.registration_no)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.org_basic_data = res.data.org_basic_data;
            this.lc_data = res.data.lc_data;
            // this.lc_data.last_school = this.org_basic_data.school_name;
            this.date_of_application = this.formatDate(
              this.lc_data.date_of_application
            );
            this.date_of_issue = this.formatDate(this.lc_data.date_of_issue);

            // this.showSnackbar("green", "User data fetched!!!");
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
  mounted() {
    localStorage.setItem("lc_data", null);
    localStorage.setItem("org_basic_data", null);
    localStorage.setItem("last_date_of_school", "");
    this.onload();
    this.last_date_of_school = this.formatDate(this.date);
    this.gen_date = this.formatDate(this.date2);
    this.application_date = this.formatDate(this.date_of_application);
    this.issue_date = this.formatDate(this.date_of_issue);
    this.org_id = localStorage.getItem("EPS-org-id")
  },
};
</script>
<style scoped>
.white-text{
  color: white !important;
}
.scroll {
  overflow-x: scroll;
}
.mytable1 /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
.mytable /deep/ thead th {
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
  background: #83a4d4; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #265fb1,
    #b6fbff
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #265fb1,
    #b6fbff
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
tr,
td,
th {
  /* border: 1px solid #ccc; */
  text-align: center;
  font-size: small;
}
tr,
tbody {
  font-size: small;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}
.expapanel {
  width: 93%;
  margin-left: 3%;
}

.panelheader {
  /* background: linear-gradient(to right, #2c5364, #203a43, #0f2027); */
  color: white !important;
  background: #83a4d4; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #3792c7,
    #60e3eb,
    #a0dfe3
  ); /* Chrome 10-25, Safari 5.1-6 */
  /* background: linear-gradient(to right,  #83a4d4, #a0dfe3); W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  font-size: 16px;
  background: linear-gradient(to right, #3792c7, #60e3eb, #a0dfe3);
}
.fees span {
  font-size: 23px;
  font-weight: 600;
}
/* lc data css */
.printdiv {
  height: auto;
  margin-left: 15%;
  margin-right: 15%;
  background-color: rgb(248, 248, 241);
  background-position: center;
}
.text-color{
  color: #233491;
  padding: 20px;
}
.jr-table{ 
  border-collapse: collapse;
}
.jr-table td:nth-child(2){
  border-right: none;
}
.jr-table td:first-child{
  width: 30%;
  border-left: none !important;
}
.jr-table, .jr-table td, .jr-table tr{
 border: 1px solid rgb(235, 61, 61); 
 text-align: left; 
 font-size: 17px;
}
.header {
  margin: 6px;
}
.last-row {
  display: flex;
  justify-content: space-around;
  width: 100%;
  /* margin-bottom: -15px; */
}
.content {
  padding-bottom: 20px;
}
.align-center {
  padding-top: 50px;
  font-size: medium;
}
p {
  font-size: medium;
  margin: 0;
  font-weight: 600;
}
h1 {
  color: rgb(235, 61, 61);
}
.jr-last-row{
  color: rgb(235, 61, 61); 
  margin-top: 90px; 
  margin-bottom: 10px;
}
/* lc data css end */

/* print lc css */
@media print {
  .pagebreak {
    page-break-before: always;
  }
  header,
  footer,
  nav,
  date {
    display: none !important;
  }

  body,
  tr,
  th,
  td {
    font-size: x-large !important;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
  v-card {
    border: none !important;
  }
  .printdiv {
    margin: 0;
    padding: 0;
  }
  #document1 {
    position: absolute;
    margin-top: -63px;
    top: 0;
    /* left: 0;
    right: 0; */
    bottom: 0;
  }
  .text-color{
    padding: 20px !important;
    margin-left: -15px;
  }
  .jr-table,.jr-table td{
    height: 40px !important;
    font-size: 21px !important;
  }
  .jr-last-row{
    margin-top: 110px !important;
    font-size: 20px !important;
  }
  @page {
    size: A4;
    margin: none;
    padding-top: none;
    size: 11.5in 16.5in;
  }
}
/* print lc css end */

.style-1 {
  background-color: rgb(215, 84, 44);
  font-weight: bolder;
}
.style-2 {
  background-color: rgb(61, 219, 21);
}
span.stretch {
  display: inline-block;
  -webkit-transform: scale(1.5, 1); /* Safari and Chrome */
  -moz-transform: scale(1.3, 1); /* Firefox */
  -ms-transform: scale(1.5, 1); /* IE 9 */
  -o-transform: scale(1.5, 1); /* Opera */
  /* transform: scale(1.3,1); */
  /* margin-left: 25%; */
  font-size: 14px;
}
.stretch1 {
  display: inline-block;
  -webkit-transform: scale(1.3, 1); /* Safari and Chrome */
  -moz-transform: scale(1.3, 1); /* Firefox */
  -ms-transform: scale(1.5, 1); /* IE 9 */
  -o-transform: scale(1.5, 1); /* Opera */
  /* transform: scale(1.3,1); */
  /* margin-left: 25%; */
  font-size: 14px;
}

h3.stretch2 {
  display: inline-block;
  -webkit-transform: scale(2, 1); /* Safari and Chrome */
  -moz-transform: scale(1.5, 1); /* Firefox */
  -ms-transform: scale(1.5, 1); /* IE 9 */
  -o-transform: scale(1.5, 1); /* Opera */
}
</style>